(function ($, document, window) {
	var packageMatrixBlock = {
		init: function () {
			if ($('.c-puffs > input') === undefined | $('.c-puffs > input').val() === undefined) {
				$('.js-puff-slider').css('align-items', 'inherit');
				$('.c-puff__content').css('padding-bottom', '5rem');
				$('.c-puff__action').css('position', 'absolute');
			}
			$(window).on('load', function() {
				var buttons = $('.js-expandBtn');

				for (var i = 0; i < buttons.length; i++) {
					var id = buttons[i].dataset.id;
					var body = $('#' + id);
					var height = $(body)[0].offsetHeight;
				
					if ($('.c-puffs > input') !== undefined && $('.c-puffs > input').val() !== undefined) {
						var maxHeight = $('.c-puffs > input').val();
					
						if (height <= maxHeight) {
							$(buttons[i]).css('display', 'none');
						}
						$(body)[0].style.height = maxHeight + 'px';
						$(body)[0].style.minHeight = maxHeight + 'px';
					} else {					
						$(buttons[i]).parent().css('display', 'none');
					}
				}
			});
		}
	};
	packageMatrixBlock.init();
})(jQuery, document, window);